import useGetUserToken from "@/lib/auth/useGetUserToken";
import { useQuery } from "@tanstack/react-query";
import { CHECKOUT_EVENTS } from "../../events.checkout";
import { getMissingFeature } from "../../handlers/getMissingFeature";
import { CheckoutService } from "../../service.checkout";

export const MISSING_FEATURE_QUERY_KEY = "missing-feature";

interface UseMissingFeatureOptions {
  productIds: string[];
  enabled?: boolean;
}

export function useMissingFeatureQuery({
  productIds,
  enabled = true,
}: UseMissingFeatureOptions) {
  const userToken = useGetUserToken();

  const query = useQuery({
    queryKey: [MISSING_FEATURE_QUERY_KEY, productIds],
    queryFn: async () => {
      try {
        const data = await getMissingFeature({ productIds, token: userToken });
        CheckoutService.track(CHECKOUT_EVENTS.MISSING_FEATURE_LOADED, {
          types: ["posthog", "customerio"],
        });
        return data;
      } catch (error) {
        CheckoutService.track(CHECKOUT_EVENTS.MISSING_FEATURE_FAILED, {
          types: ["posthog", "customerio"],
          properties: {
            error: error instanceof Error ? error.message : "Unknown error",
          },
        });
        throw error;
      }
    },
    enabled: enabled && productIds.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    missingFeatures: query.data?.missing_out || [],
    country: query.data?.country,
    language: query.data?.language,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
